module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "analytics"
    }
  }, [_c('v-panel', {
    staticClass: "analytic_w"
  }, [_c('div', {
    staticClass: "page-header-wrapper",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-747e5ac2"}!./src/app/pages/analytics/index/index.html
// module id = 1417
// module chunks = 0